import { useEffect, useState } from "react"
import { skipToken } from "@reduxjs/toolkit/query"
import { useAppSelector } from "@/store"
import { benefitApi } from "./benefitApi"

export function useBenefitScopeArg(enabled = true) {
  const scopeKey = useAppSelector(state => state.staffSession.scopeKey)
  return scopeKey && enabled ? { scopeKey } : skipToken
}

/** Only search input/timing is local. Results always belong to the exact scoped RTK key. */
export function useDebouncedBenefitInput(value: string, delay: number) {
  const [settled, setSettled] = useState<string | null>(null)
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])
  return settled === value ? settled : null
}

export function useBenefitBackupPreview(benefitId: string, observedApplicationDate: string, programYear: number | null | undefined,
  energyType: number | string | null | undefined, enabled: boolean) {
  const scope = useBenefitScopeArg(enabled)
  // Zero is a valid enum value. Blank/unknown is not zero, and disabling backup must
  // immediately hide the previous key, even while its request is still in flight.
  const numericType = energyType == null || energyType === "" ? null : Number(energyType)
  const args = scope !== skipToken && programYear != null && Number.isInteger(numericType)
    ? { ...scope, benefitId, observedApplicationDate, programYear, energyType: numericType! } : skipToken
  const query = benefitApi.useGetBenefitPseBackupCostsQuery(args)
  return {
    preview: args !== skipToken && !query.isError && !query.isFetching ? query.currentData ?? null : null,
    loading: args !== skipToken && (query.isUninitialized || query.isFetching),
    error: args !== skipToken && query.isError ? "PSE backup settings could not be loaded." : null,
  }
}
